import React from "react";
import { Button, CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { MokshaBadge } from "../../components/MokshaMarkers";
import { focusRing } from "./presentation";

export const CONTROL_HEIGHT = 40;
export const SPINNER_SIZE = 22;
export const STALE_OPACITY = 0.5;
export const MOBILE_BAR_HEIGHT = 72;

export const useColors = () => tokens(useTheme().palette.mode);

export const panelSx = (colors) => ({ width: "100%", p: 2, borderRadius: 2, backgroundColor: colors.primary[400] });

export const PageTitle = ({ badge = true }) => (
    <Stack direction="row" spacing={1.5} alignItems="center" mb="20px">
        <Header title="MOKSHA RESERVATION" mb={0} />
        {badge && <MokshaBadge />}
    </Stack>
);

export const SectionTitle = ({ children, extra }) => (
    <Stack direction="row" alignItems="center" spacing={1} mb={1.5}>
        <Typography variant="h5" fontWeight={600} component="h2">
            {children}
        </Typography>
        {extra}
    </Stack>
);

export const SummaryRow = ({ label, value }) => (
    <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography>{label}</Typography>
        <Typography>{value}</Typography>
    </Stack>
);

export const CreateBookingButton = ({ isSaving, fullWidth, sx }) => {
    const colors = useColors();
    return (
        <Button
            fullWidth={fullWidth}
            type="submit"
            variant="contained"
            color="secondary"
            disabled={isSaving}
            sx={{ minHeight: CONTROL_HEIGHT, ...focusRing(colors), ...sx }}
        >
            {isSaving ? <CircularProgress color="inherit" size={SPINNER_SIZE} /> : <b>Create booking</b>}
        </Button>
    );
};
